module.exports = __webpack_public_path__ + "static/media/sendsms.1c02f6be.svg";